const URLS = {
  GN_ASSETS_BASE_URL: process.env.NEXT_PUBLIC_GN_ASSETS_BASE_URL,
  SUPERNOODLE_URL: "https://supernoodle.gonoodle.com",
  SUPPORT_URL: "https://support.gonoodle.com",
  PARTNER_WITH_US_URL: "https://www.partnerships.gonoodle.com",
};

export const AGE_GATED_URLS = [URLS.SUPERNOODLE_URL];
export default URLS;
